// AvatarSelector.js
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const AvatarSelector = ({ avatars, onSelect, setShowAvatarSelector }) => {
  return (
    <div className="avatar-selector-container">
      <div className="avatar-selector-popup">
        <CloseIcon
          className="cross"
          onClick={() => {
            setShowAvatarSelector(false);
          }}
        />
        <div className="pd-1">
          {avatars.map((avatar, index) => (
            <img
              className="avatar-image"
              key={index}
              src={avatar.avatarUrl}
              alt={avatar.avatarName}
              onClick={() => onSelect(avatar.avatarUrl, avatar.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvatarSelector;
